<template>
  <div class="navbar p-4">
    <div class="pb-4">
      <div>
        <div class="flex items-center">
          <img v-if="getBrand === 'enigma'" :src="`/images/brandsLogo/${getBrand}/logo.svg`" :alt="getBrand">
          <h1 v-else style="color: rgba(var(--vs-primary), 1)">{{logoName.default}}</h1>
        </div>
      </div>
      <div :class="{'logo_text--enigma': getBrand}" class="logo_text">API documentation</div>
    </div>
    <NavItems
        v-for="(item, index) of navItems"
        :key="index"
        :name="item.name"
        :url="item.url"
        :method="item.method"
    />
  </div>
</template>

<script>
import NavItems from './NavigationItem'
import Logo from '@/layouts/components/Logo'

export default {
  props: {
    navItems: {
      type: Array,
      required: true
    }
  },

  components: {
    NavItems,
    Logo
  },

  computed: {
    logoName() {
      return {
        default: process.env.VUE_APP_LOGO === undefined ?
          'Network' :
          process.env.VUE_APP_LOGO
      }
    },

    getBrand() {
      return this.$store.getters.getBrand
    },
  },

  data() {
    return {
      brand: process.env.VUE_APP_BRAND
    }
  }
}
</script>

<style lang="scss">
.navbar {
  max-width: 250px;
  width: 100%;
  position: fixed;
  height: 100%;
  top: 0;

  .logo_text {
    font-size: 10px;
    color: grey;
    margin-top: -5px;
  }

  .logo {
    font-size: 22px;
    font-weight: 600;
  }

  .logo-ml {
    margin-left: 50px;
  }
}
</style>
